<script setup lang="ts">
import { ElConfigProvider } from 'element-plus'
import zhCn from 'element-plus/es/locale/lang/zh-cn'

const version = __APP_VERSION__
const env = __APP_ENV__
</script>

<template>
  <ElConfigProvider :locale="zhCn">
    <RouterView />
    <div v-if="version" class="version-badge">v{{ version }} ({{ env }})</div>
  </ElConfigProvider>
</template>

<style scoped>
.version-badge {
  position: fixed;
  right: 8px;
  bottom: 8px;
  font-size: 12px;
  color: #999;
  z-index: 9999;
  pointer-events: none;
}
</style>